import { take, put, call, all, takeLatest } from 'redux-saga/effects';
import moment from 'moment';
import { handleExportFile } from 'src/utils/exportfile';

import {

  initOrderInfo,

  checkoutFail,
  checkoutStart,
  checkoutSuccess,

  requestPaymentTypeFail,
  requestPaymentTypeStart,
  requestPaymentTypeSuccess,

  getCartListStart,
  getCartListSuccess,
  getCartListFail,

  editCartStart,
  editCartSuccess,
  editCartFail,

  createOrderStart,
  createOrderSuccess,
  createOrderFail,

  requestOrderStart,
  requestOrderSuccess,
  requestOrderFail,

  requestDeliveryTypeFail,
  requestDeliveryTypeStart,
  requestDeliveryTypeSuccess,

  requestOrderStateFail,
  requestOrderStateStart,
  requestOrderStateSuccess,

  requestOrderHistoryListFail,
  requestOrderHistoryListStart,
  requestOrderHistoryListSuccess,

  orderHistorySetStateFail,
  orderHistorySetStateStart,
  orderHistorySetStateSuccess,

  requestOrderHistoryDetailFail,
  requestOrderHistoryDetailStart,
  requestOrderHistoryDetailSuccess,

  requestGeoFail,
  requestGeoStart,
  requestGeoSuccess,

  orderHistoryCalculateFail,
  orderHistoryCalculateStart,
  orderHistoryCalculateSuccess,

  orderHistoryEditFail,
  orderHistoryEditStart,
  orderHistoryEditSuccess,

  exportOrderHistoryFail,
  exportOrderHistoryStart,
  exportOrderHistorySuccess,

  requestOrderCalculateListStart,
  requestOrderCalculateListSuccess,
  requestOrderCalculateListFail,

} from '../actions/order';

import requestManagement from '../service/requestManagement';
const { method_POST, method_GET, method_GET_GEO, method_PUT } = requestManagement;

import CONFIG from '@root/config/config.next';
const url = CONFIG.backendEndpoint;

export function* checkout({ payload }) {

  /*console.log('[sages] checkout : ', payload);*/

  const apiURL = (payload?.active_v2) ? `${url}/backend/v2/order/checkout` : `${url}/backend/v1/order/checkout`;
  // const apiURL = `${url}/backend/v1/order/checkout`;

  //====================================================================================================================

  try {
    const data = yield method_POST({
      url: apiURL,
      data: payload?.data,
    });

    console.log('[API] POST : ', data);

    yield put(checkoutSuccess(data));
  } catch (error) {
    yield put(checkoutFail(error));
  }

  //====================================================================================================================
}

export function* requestPaymentType({ payload }) {
  /*console.log('[sages] requestPaymentType : ', payload);*/

  const apiURL = `${url}/backend/v1/order/payment-type`;

  //====================================================================================================================

  try {
    const data = yield method_GET({
      url: apiURL,
      data: payload?.data,
    });

    /*console.log('[API] GET : ', data);*/

    yield put(requestPaymentTypeSuccess(data));
  } catch (error) {
    yield put(requestPaymentTypeFail(error));
  }

  //====================================================================================================================
}

export function* getCartList({ payload }) {
  /*console.log('[sages] getCartList : ', payload);*/

  const apiURL = `${url}/member/v1/account/search`;

  //====================================================================================================================

  try {
    const data = yield method_POST({
      url: apiURL,
      data: payload?.data,
    });

    /*console.log('[API] GET : ');*/

    yield put(getCartListSuccess(data));
  } catch (error) {
    yield put(getCartListFail(error));
  }

  //====================================================================================================================
}

export function* editCart({ payload }) {
  /*console.log('[sages] editCart : ', payload);*/

  // const apiURL = `${url}/backend/v2/order/cart`;
  const apiURL = `${url}/backend/v1/order/cart`;

  //====================================================================================================================

  try {
    const data = yield method_PUT({
      url: apiURL,
      data: payload?.data,
    });

    /*console.log('[API] GET : ');*/

    yield put(editCartSuccess(data));
  } catch (error) {
    yield put(editCartFail(error));
  }

  //====================================================================================================================
}

export function* createOrder({ payload }) {
  /*console.log('[sages] createOrder : ', payload);*/

  // const apiURL = `${url}/backend/v1/order/create`;
  const apiURL = (payload?.active_v2) ? `${url}/backend/v2/order/create` : `${url}/backend/v1/order/create`;
  //====================================================================================================================

  try {
    const data = yield method_POST({
      url: apiURL,
      data: payload?.data,
    });

    /*console.log('[API] POST : ', data);*/

    yield put(createOrderSuccess(data));
  } catch (error) {
    yield put(createOrderFail(error));
  }

  //====================================================================================================================
}

export function* requestOrderHistoryList({ payload }) {

  /*console.log('[sages] requestOrderHistoryList : ', payload);*/

  // const apiURL = `${url}/backend/v1/order/history`;
  const apiURL = `${url}/backend/v2/order/history`;

  //====================================================================================================================

  try {
    const data = yield method_POST({
      url: apiURL,
      data: payload?.data,
      params: payload?.params,
    });

    /*console.log('[API] POST : ', data);*/

    yield put(requestOrderHistoryListSuccess(data));
  } catch (error) {
    yield put(requestOrderHistoryListFail(error));
  }

  //====================================================================================================================
}

export function* requestOrderState({ payload }) {
  /*console.log('[sages] requestOrderState : ', payload);*/

  const apiURL = (payload?.active_v2) ? `${url}/backend/v2/order/order-state` : `${url}/backend/v1/order/order-state`;
  //====================================================================================================================

  try {
    const data = yield method_GET({
      url: apiURL,
      data: payload?.data,
    });

    /*console.log('[API] GET : ', data);*/

    yield put(requestOrderStateSuccess(data));
  } catch (error) {
    yield put(requestOrderStateFail(error));
  }

  //====================================================================================================================
}

export function* requestOrder({ payload }) {
  /*console.log('[sages] requestOrder : ', payload);*/

  const apiURL = `${url}/backend/v1/order/order-`;

  //====================================================================================================================

  try {
    const data = yield method_GET({
      url: apiURL,
      data: payload?.data,
    });

    /*console.log('[API] GET : ', data);*/

    yield put(requestOrderSuccess(data));
  } catch (error) {
    yield put(requestOrderFail(error));
  }

  //====================================================================================================================
}

export function* requestDeliveryType({ payload }) {
  /*console.log('[sages] requestDeliveryType : ', payload);*/

  const apiURL = `${url}/backend/v2/order/delivery-type`;
  // const apiURL = `${url}/backend/v1/order/delivery-type`;

  //====================================================================================================================

  try {
    const data = yield method_GET({
      url: apiURL,
      data: payload?.data,
    });

    /*console.log('[API] GET : ', data);*/

    yield put(requestDeliveryTypeSuccess(data));
  } catch (error) {
    yield put(requestDeliveryTypeFail(error));
  }

  //====================================================================================================================
}

export function* orderHistorySetState({ payload }) {
  /*console.log('[sages] orderHistorySetState : ', payload);*/

  const apiURL = `${url}/backend/v2/order/history/${payload?.uuid}/state`;

  //====================================================================================================================

  try {
    const data = yield method_PUT({
      url: apiURL,
      data: payload?.data,
    });

    console.log('[API] PUT : ', { data });

    if (data.code === 0) {

      yield put(orderHistorySetStateSuccess(data));

    }
    else if (data?.response?.data?.code !== 0) {

      const { code, error, msg } = data?.response?.data || {};
      console.log('[API] PUT : ', code, error, msg,);

      yield put(orderHistorySetStateSuccess(data?.response?.data));

    }
    else {

      console.log('[API] PUT : [data]', { data });

      yield put(orderHistorySetStateFail(data));
    }

  } catch (error) {

    console.log('[API] PUT : [erorr]',)

    yield put(orderHistorySetStateFail(error));
  }

  //====================================================================================================================
}

export function* requestOrderHistoryDetail({ payload }) {
  /*console.log('[sages] requestOrderHistoryDetail : ', payload);*/

  // const apiURL = `${url}/backend/v1/order/history/${payload?.data?.uuid}`;
  const apiURL = (payload?.active_v2) ?
    `${url}/backend/v2/order/history/${payload?.data?.uuid}` :
    `${url}/backend/v1/order/history/${payload?.data?.uuid}`;

  //====================================================================================================================

  try {
    const data = yield method_POST({
      url: apiURL,
      data: payload?.data,
      params: payload?.params,
    });

    /*console.log('[API] POST : ', data);*/

    yield put(requestOrderHistoryDetailSuccess(data));
  } catch (error) {
    yield put(requestOrderHistoryDetailFail(error));
  }

  //====================================================================================================================
}

export function* requestGeo({ payload }) {
  /*console.log('[sages] requestGeo : ', payload);*/

  const apiURL = `https://assets.jenosize.io/api/v1/geolocation/`;

  //====================================================================================================================

  try {
    const data = yield method_GET_GEO({
      url: apiURL,
      data: payload?.data,
      params: payload?.params,
      header: { Authorization: 'Bearer 4uB6kBBKtZaSHXCJ2IVF' },
    });

    /*console.log('[API] GET : ', data);*/

    yield put(requestGeoSuccess(data));
  } catch (error) {
    yield put(requestGeoFail(error));
  }

  //====================================================================================================================
}

export function* orderHistoryCalculate({ payload }) {
  /*console.log('[sages] orderHistoryCalculate : ', payload);*/

  const apiURL = (payload?.active_v2) ?
    `${url}/backend/v2/order/history/${payload?.data?.uuid}/calculate` :
    `${url}/backend/v1/order/history/${payload?.data?.uuid}/calculate`;

  //====================================================================================================================

  try {
    const data = yield method_PUT({
      url: apiURL,
      data: payload?.data,
    });

    // console.log('[API] PUT : ', data);

    if (data?.code === 0) {

      yield put(orderHistoryCalculateSuccess(data));

    }
    else {

      // const { code, error, msg } = data?.response?.data || {};
      // console.log('[API] PUT : ', data?.response);

      yield put(orderHistoryCalculateFail(data?.response?.data));
    }

  } catch (error) {
    yield put(orderHistoryCalculateFail(error));
  }

  //====================================================================================================================
}

export function* orderHistoryEdit({ payload }) {
  /*console.log('[sages] orderHistoryEdit : ', payload);*/

  const apiURL = (payload?.active_v2) ?
    `${url}/backend/v2/order/history/${payload?.data?.uuid}/edit` :
    `${url}/backend/v1/order/history/${payload?.data?.uuid}/edit`;

  //====================================================================================================================

  try {
    const data = yield method_PUT({
      url: apiURL,
      data: payload?.data,
    });

    /*console.log('[API] PUT : ', data);*/

    yield put(orderHistoryEditSuccess(data));
  } catch (error) {
    yield put(orderHistoryEditFail(error));
  }

  //====================================================================================================================
}

export function* exportOrderHistory({ payload }) {
  /*console.log('[sages] exportOrderHistory : ', payload);*/

  //====================================================================================================================

  try {
    yield handleExportFile(payload?.params, payload?.fileName, 'POST');
    yield put(exportOrderHistorySuccess());
  } catch (error) {
    yield put(exportOrderHistoryFail());
  }

  //====================================================================================================================
}

export function* requestOrderCalculate({ payload }) {

  /*console.log('[sages] editCart : ', payload);*/

  const apiURL = `${url}/backend/v2/order/calculate`;

  //====================================================================================================================

  try {
    const data = yield method_POST({
      url: apiURL,
      data: payload?.data,
    });

    /*console.log('[API] GET : ');*/

    yield put(requestOrderCalculateListSuccess(data));
  } catch (error) {
    yield put(requestOrderCalculateListFail(error));
  }

  //====================================================================================================================
}

export function* watchOrder() {
  /*console.log('[sages] watchCategory : ✅');*/

  yield all([
    takeLatest(checkoutStart, checkout),
    takeLatest(requestPaymentTypeStart, requestPaymentType),
    takeLatest(getCartListStart, getCartList),
    takeLatest(editCartStart, editCart),
    takeLatest(createOrderStart, createOrder),
    // takeLatest(requestOrderStart, requestOrder),
    takeLatest(requestOrderStateStart, requestOrderState),
    takeLatest(requestDeliveryTypeStart, requestDeliveryType),
    takeLatest(requestOrderHistoryListStart, requestOrderHistoryList),
    takeLatest(orderHistorySetStateStart, orderHistorySetState),
    takeLatest(requestOrderHistoryDetailStart, requestOrderHistoryDetail),
    takeLatest(requestGeoStart, requestGeo),
    takeLatest(orderHistoryCalculateStart, orderHistoryCalculate),
    takeLatest(orderHistoryEditStart, orderHistoryEdit),
    takeLatest(exportOrderHistoryStart, exportOrderHistory),
    takeLatest(requestOrderCalculateListStart, requestOrderCalculate)
  ]);
}
